import { Link } from 'react-router-dom'
import { useI18n } from '../../i18n'
import { Logo } from '../ui/Logo'

export function Footer() {
  const { t } = useI18n()

  return (
    <footer className="border-t border-black/[0.04]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-flex items-center gap-2 text-lg font-semibold mb-3">
              <Logo size={24} />
              <span className="text-[#1a1a1a]">PrimeBook</span>
              <span className="text-orange-500">AI</span>
            </Link>
            <p className="text-xs text-gray-400 leading-relaxed">
              {t('企业级AI智能管家平台', 'Enterprise AI Butler Platform')}
              <br />
              {t('为企业打造专属AI管家', 'Building dedicated AI Butlers for enterprises')}
            </p>
          </div>

          <div>
            <h4 className="text-xs font-medium text-gray-500 mb-3 uppercase tracking-wider">{t('产品', 'Product')}</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#capabilities" className="hover:text-[#1a1a1a] transition-colors">{t('AI管家', 'AI Butler')}</a></li>
              <li><a href="#capabilities" className="hover:text-[#1a1a1a] transition-colors">{t('知识库', 'Knowledge Base')}</a></li>
              <li><a href="#capabilities" className="hover:text-[#1a1a1a] transition-colors">{t('API服务', 'API Service')}</a></li>
              <li><a href="#how-it-works" className="hover:text-[#1a1a1a] transition-colors">{t('私有化部署', 'Private Deploy')}</a></li>
              <li><Link to="/pricing" className="hover:text-[#1a1a1a] transition-colors">{t('定价方案', 'Pricing Plans')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-medium text-gray-500 mb-3 uppercase tracking-wider">{t('公司', 'Company')}</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/about" className="hover:text-[#1a1a1a] transition-colors">{t('关于我们', 'About Us')}</Link></li>
              <li><a href="#" className="hover:text-[#1a1a1a] transition-colors">{t('加入我们', 'Careers')}</a></li>
              <li><a href="#" className="hover:text-[#1a1a1a] transition-colors">{t('联系方式', 'Contact')}</a></li>
              <li><a href="#" className="hover:text-[#1a1a1a] transition-colors">{t('博客', 'Blog')}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-medium text-gray-500 mb-3 uppercase tracking-wider">{t('法律', 'Legal')}</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#" className="hover:text-[#1a1a1a] transition-colors">{t('隐私政策', 'Privacy Policy')}</a></li>
              <li><a href="#" className="hover:text-[#1a1a1a] transition-colors">{t('服务条款', 'Terms of Service')}</a></li>
              <li><a href="#" className="hover:text-[#1a1a1a] transition-colors">{t('数据安全', 'Data Security')}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-black/[0.04]">
          <p className="text-xs text-gray-300">
            &copy; {new Date().getFullYear()} PrimeBook AI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
